import { excuseApi } from "../commons/http";

class Product {
    constructor(data = {}) {
        this.name = data.name;
        this.description = data.description;
        this.image = data.image;
        this.expire_days = data.expire_days;
        this.convert_rate = data.convert_rate;
        this.latest_price = data.latest_price;
        this.is_combo = data.is_combo || false;
        this.components = data.components || [];
        this.status = data.status || 'ACTIVE';
    }

    mapData(data) {
        this.id = data.id
        this.name = data.name;
        this.description = data.description;
        this.image = data.image;
        this.expire_days = data.expire_days;
        this.convert_rate = data.convert_rate;
        this.latest_price = data.latest_price;
        this.is_combo = data.is_combo || false;
        this.components = data.components || [];
        this.status = data.status || 'ACTIVE';
    }

    async createProduct() {
        const res = await excuseApi({
            path: '/products',
            method: 'POST',
            body: {
                name: this.name,
                description: this.description,
                image: this.image,
                expire_days: this.expire_days,
                convert_rate: this.convert_rate,
                is_combo: this.is_combo,
            }
        });
        if (res.status === 200 || res.status === 201) {
            const productId = res.data.data.id;
            return { success: true, message: "Thêm sản phẩm thành công", id:productId };
        }
        else {
            return { success: false, message: "Thêm sản phẩm thất bại" };
        }
    }

    async getProductById(id) {
        try {
            const res = await excuseApi({
                path: `/products/${id}`,
                method: 'GET',
            });
            if (res.status === 200 || res.status === 201) {
                return res.data.data;
            }
            else {
                return null;
            }
        }
        catch (error) {
            throw error;
        }
    }

    async updateProduct(id) {
        try {
            const res = await excuseApi({
                path: `/products/${id}`,
                method: 'PUT',
                body: {
                    name: this.name,
                    description: this.description,
                    image: this.image,
                    expire_days: this.expire_days,
                    convert_rate: this.convert_rate,
                    status: this.status,
                }
            });
            if (res.status === 200 || res.status === 201) {
                return {success: true, message:"Thay đổi thông tin sản phẩm thành công"};
            }
            else {
                return {success: false, message: res.data?.message || "Thay đổi thông tin sản phẩm thất bại", error: res.data?.message};
            }
        }
        catch (error) {
            // Handle combo validation error - backend returns { error: "message" }
            if (error.response?.data?.error) {
                return {success: false, message: error.response.data.error, error: error.response.data.error};
            }
            throw error;
        }
    }

    // Combo component methods
    async getComboComponents(productId) {
        try {
            const res = await excuseApi({
                path: `/products/${productId}/components`,
                method: 'GET',
            });
            if (res.status === 200 || res.status === 201) {
                return res.data.data;
            }
            return [];
        }
        catch (error) {
            console.error('Error fetching components:', error);
            return [];
        }
    }

    async addComponent(productId, componentProductId, quantity) {
        try {
            const res = await excuseApi({
                path: `/products/${productId}/components`,
                method: 'POST',
                body: {
                    combo_product_id: productId,
                    component_product_id: componentProductId,
                    quantity: quantity,
                }
            });
            if (res.status === 200 || res.status === 201) {
                return { success: true, message: "Thêm thành phần thành công", data: res.data.data };
            }
            else {
                return { success: false, message: res.data.error || "Thêm thành phần thất bại" };
            }
        }
        catch (error) {
            return { success: false, message: error.response?.data?.error || "Thêm thành phần thất bại" };
        }
    }

    async updateComponent(productId, componentId, quantity) {
        try {
            const res = await excuseApi({
                path: `/products/${productId}/components/${componentId}`,
                method: 'PUT',
                body: {
                    quantity: quantity,
                }
            });
            if (res.status === 200 || res.status === 201) {
                return { success: true, message: "Cập nhật thành phần thành công" };
            }
            else {
                return { success: false, message: "Cập nhật thành phần thất bại" };
            }
        }
        catch (error) {
            return { success: false, message: "Cập nhật thành phần thất bại" };
        }
    }

    async removeComponent(productId, componentId) {
        try {
            const res = await excuseApi({
                path: `/products/${productId}/components/${componentId}`,
                method: 'DELETE',
            });
            if (res.status === 200 || res.status === 201) {
                return { success: true, message: "Xóa thành phần thành công" };
            }
            else {
                return { success: false, message: res.data.error || "Xóa thành phần thất bại" };
            }
        }
        catch (error) {
            return { success: false, message: error.response?.data?.error || "Xóa thành phần thất bại" };
        }
    }

    // Product conversion methods
    async getConversionInfo(productId) {
        try {
            const res = await excuseApi({
                path: `/products/${productId}/conversion-info`,
                method: 'GET',
            });
            if (res.status === 200 || res.status === 201) {
                return { success: true, data: res.data.data };
            }
            return { success: false, message: "Không thể lấy thông tin chuyển đổi" };
        }
        catch (error) {
            console.error('Error fetching conversion info:', error);
            return { success: false, message: error.response?.data?.error || "Không thể lấy thông tin chuyển đổi" };
        }
    }

    async convertProduct(productId, convertToCombo, clearInventory = false) {
        try {
            const res = await excuseApi({
                path: `/products/${productId}/convert`,
                method: 'POST',
                body: {
                    convert_to_combo: convertToCombo,
                    clear_inventory: clearInventory,
                }
            });
            if (res.status === 200 || res.status === 201) {
                return { success: true, message: res.data.message, data: res.data.data };
            }
            else {
                return { success: false, message: res.data.error || "Chuyển đổi sản phẩm thất bại" };
            }
        }
        catch (error) {
            return {
                success: false,
                message: error.response?.data?.error || "Chuyển đổi sản phẩm thất bại",
                details: error.response?.data
            };
        }
    }
}
export default Product;